module.exports = __webpack_public_path__ + "static/media/psd2tool.04724984.png";